// ------------ A C U E R D O S    I T E ------------
export const dataAcuerdos2026 = [
  {
    id: 1,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE ACTUALIZA LA CALENDARIZACIÓN DE LAS CANTIDADES A RETENER POR MULTAS PENDIENTES POR PAGAR Y SE CALENDARIZA LA RETENCIÓN DE MULTAS A PARTIDOS POLITICOS, AMBOS SUPUESTOS DERIVADOS DE RESOLUCIONES Y ACUERDOS DEL INSTITUTO NACIONAL ELECTORAL Y DE ESTE INSTITUTO. ",
    titleAnexo1: "ANEXO UNO",
    titleAnexo2: "ANEXO DOS",
  },
  {
    id: 2,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE APRUEBA EL INFORME DE OTORGAMIENTO DE INCENTIVOS 2025, CORRESPONDIENTE AL EJERCICIO VALORADO 2024, A PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DE ESTE INSTITUTO",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 3,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE CALENDARIZA LA RETENCIÓN DE LA MULTA PREVISTA EN LA RESOLUCIÓN INE/CG2107/2024, DEL INSTITUTO NACIONAL ELECTORAL.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 4,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE READECÚA EL PRESUPUESTO DE EGRESOS DEL EJERCICIO FISCAL DOS MIL VEINTISÉIS, DE ESTE INSTITUTO.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 5,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE APRUEBA EL PROGRAMA DE IMPARTICIÓN DE SEMINARIOS, CONFERENCIAS, COLOQUIOS, DIPLOMADOS, MESAS REDONDAS, DIVULGACIÓN DE TEXTOS, PUBLICACIÓN DE RESULTADOS DE INVESTIGACIÓN Y PRESENTACIÓN DE LIBROS 2026, ELABORADO POR LA JUNTA GENERAL EJECUTIVA.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 6,
    typeDoc: "ACUERDO",
    monthDoc: "ENE",
    nameDoc: "POR EL QUE SE ESTABLECE EL PROCEDIMIENTO PARA LA EJECUCIÓN DE LAS MULTAS PREVISTAS EN LA RESOLUCIÓN INE/CG985/2025 MODIFICADA MEDIANTE LOS ACUERDOS INE/CG1339/2025, INE/CG1341/2025, INE/CG1403/2025 E INE/CG1404/2025 DEL INSTITUTO NACIONAL ELECTORAL.",
  },
  {
    id: 7,
    typeDoc: "ACUERDO",
    monthDoc: "FEB",
    nameDoc: "POR EL QUE SE APRUEBA EL DICTAMEN GENERAL DE RESULTADOS DE LA EVALUACIÓN DEL DESEMPEÑO DEL PERSONAL DEL SERVICIO PROFESIONAL ELECTORAL NACIONAL DEL SISTEMA DE LOS ORGANISMOS PÚBLICOS LOCALES ELECTORALES, CORRESPONDIENTE AL PERIODO SEPTIEMBRE 2024 A AGOSTO 2025.",
    titleAnexo1: "ANEXO UNICO",
  },
  {
    id: 8,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PAN-CFyCT/CG/011/2025.",
  },
  {
    id: 9,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PT/CG/010/2025.",
  },
  {
    id: 10,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/MC/CG/009/2025.",
  },
  {
    id: 11,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/CA/CG/080/2025.",
  },
  {
    id: 12,
    typeDoc: "RESOLUCION",
    monthDoc: "FEB",
    nameDoc: "DICTADA POR EL CONSEJO GENERAL DEL INSTITUTO TLAXCALTECA DE ELECCIONES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/CA/CG/081/2025.",
  },
  {
    id: 13,
    typeDoc: "RESOLUCION",
    monthDoc: "MAR",
    nameDoc: "RESPECTO DE LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES DENTRO DEL CUADERNO DE ANTECEDENTES CQD/CA/CG/079/2025; EN CUMPLIMIENTO A LA SENTENCIA DICTADA POR EL PLENO DEL TRIBUNAL ELECTORAL DE TLAXCALA, DENTRO DEL EXPEDIENTE ELECTORAL TET-JE-019/2026.",
  },
  {
    id: 14,
    typeDoc: "ACUERDO",
    monthDoc: "MAR",
    nameDoc: "POR EL QUE SE APRUEBA REALIZAR LAS CONSULTAS DIRIGIDAS A PERSONAS, PUEBLOS Y COMUNIDADES INDÍGENAS, PERSONAS CON DISCAPACIDAD Y POBLACIONES LGBTTTIQA+, PARA LA IMPLEMENTACIÓN DE ACCIONES AFIRMATIVAS EN EL MARCO DEL PRÓXIMO PROCESO ELECTORAL LOCAL ORDINARIO 2026-2027. ",
    titleAnexo1: "ANEXO UNO",
    titleAnexo1_1: "SUBANEXO UNO DEL ANEXO UNO",
    titleAnexo1_2: "SUBANEXO DOS DEL ANEXO UNO",
    titleAnexo2: "ANEXO DOS",
    titleAnexo3: "ANEXO TRES",
    titleAnexo4: "ANEXO CUATRO",
    titleAnexo4_1: "SUBANEXO UNO DEL ANEXO CUATRO",
    titleAnexo4_2: "SUBANEXO DOS DEL ANEXO CUATRO",
    titleAnexo5: "ANEXO CINCO",
    titleAnexo6: "ANEXO SEIS",
    titleAnexo7: "ANEXO SIETE",
    titleAnexo8: "ANEXO OCHO",
    titleAnexo9: "ANEXO NUEVE",
    titleAnexo10: "ANEXO DIEZ",
    titleAnexo10_1: "SUBANEXO UNO DEL ANEXO DIEZ",
  },
  {
    id: 15,
    typeDoc: "RESOLUCION",
    monthDoc: "ABR",
    nameDoc: "POR EL QUE SE DECLARA LA PROCEDENCIA CONSTITUCIONAL Y LEGAL RESPECTO A LA MODIFICACIÓN DE LOS ESTATUTOS DEL PARTIDO POLÍTICO LOCAL NUEVA ALIANZA TLAXCALA.",
  },
  {
    id: 16,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc: "RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/PRDT/CG/037/2026.",
    titleAnexo1: "ANEXO UNICO",
  },
  /* {
    id: 17,
    typeDoc: "RESOLUCION",
    monthDoc: "ABR",
    nameDoc: "",
  }, */
  {
    id: 18,
    typeDoc: "ACUERDO",
    monthDoc: "ABR",
    nameDoc: "RELATIVO A LA SOLICITUD DE ADOPTAR MEDIDAS CAUTELARES, DENTRO DEL PROCEDIMIENTO ORDINARIO SANCIONADOR CQD/Q/JPCR/039/2026.",
  },
  /* {
    id: 19,
    typeDoc: "RESOLUCION",
    monthDoc: "ABR",
    nameDoc: "",
  }, */
];

// ------------ A C U E R D O S    I N E ------------
export const dataAcuerdosINE2026 = [
  {
    id: 171,
    typeDoc: "ACUERDO",
    numDoc: "INE/CG171/2026",
    nameDoc:
      "ACUERDO DEL CONSEJO GENERAL DEL INSTITUTO NACIONAL ELECTORAL POR EL QUE SE APRUEBAN LAS CONVOCATORIAS PARA EL PROCESO DE SELECCIÓN Y DESIGNACIÓN DE LAS PRESIDENCIAS DE LOS ORGANISMOS PÚBLICOS LOCALES DE LAS ENTIDADES DE CAMPECHE, COLIMA, COAHUILA Y TAMAULIPAS, ASÍ COMO DE LAS CONSEJERÍAS ELECTORALES DE LOS ORGANISMOS PÚBLICOS LOCALES DE LAS ENTIDADES DE CHIAPAS, DURANGO, GUERRERO, HIDALGO, NAYARIT, ОАХАСА, PUEBLA, QUINTANA ROO, SINALOA, TAMAULIPAS, TLAXCALA Y VERACRUZ",
    titleAnexoPDF1: "FE DE ERRATAS",
  },
];
